let allItems = [];
let filteredItems = [];
let currentPage = 1;
const PAGE_SIZE = 15;

function ready(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
}

ready(function () {
  const authorLinks = document.querySelectorAll('.author-list__col .author-list__photo');
  const authorListItems = document.querySelectorAll('.author-list__col');
  for (let i = 0; i < authorLinks.length; i++) {
    const role = authorLinks[i].getAttribute('href') || '';
    if (role.includes('editors') || role.includes('illustrators')) {
      authorListItems[i].remove();
    }
  }

  sortAuthors();

  document.querySelectorAll('.alphabet-nav a').forEach(function (a) {
    a.addEventListener('click', handleAlphabetClick);
  });

  allItems = Array.from(document.querySelectorAll('.author-list__col'));
  filteredItems = allItems.slice();
  paginate(1);
});


function handleAlphabetClick(evt) {
  evt.preventDefault();
  const navItem = evt.currentTarget;

  if (navItem.classList.contains('active')) {
    navItem.classList.remove('active');
  } else {
    filteredItems = [];
    document.querySelectorAll('.alphabet-nav a').forEach(function (a) {
      a.classList.remove('active');
    });
    navItem.classList.add('active');
    sortAuthorsByStartLetter(navItem.textContent.toLowerCase());
  }
  filteredItems = allItems.filter(isVisible);
  paginate(1);
}

function handlePaginate(event) {
  event.preventDefault();
  let page = event.currentTarget.textContent;
  if (page === 'Previous')      page = currentPage - 1;
  else if (page === 'Next')     page = currentPage + 1;
  else                          page = +page;
  paginate(page);
}


function paginate(pageNumber) {
  currentPage = pageNumber;

  const pages = chunk(Object.keys(filteredItems), PAGE_SIZE);
  const pageItems = pages[currentPage - 1] || [];

  const numbersEl = document.querySelector('.author-pagination .numbers');
  const prevEl    = document.querySelector('.author-pagination .prev');
  const nextEl    = document.querySelector('.author-pagination .next');
  numbersEl.innerHTML = '';
  prevEl.innerHTML    = '';
  nextEl.innerHTML    = '';

  function makePaginationItem(text, prev, next) {
    const pageEl = document.createElement('a');
    pageEl.setAttribute('href', '#' + text);
    pageEl.textContent = text;
    if (prev) {
      pageEl.id = 'prevPage';
      prevEl.appendChild(pageEl);
    } else if (next) {
      pageEl.id = 'nextPage';
      nextEl.appendChild(pageEl);
    } else {
      if (text === currentPage) pageEl.className = 'active';
      numbersEl.appendChild(pageEl);
    }
  }

  if (pages.length > 1) {
    if (currentPage !== 1) {
      makePaginationItem('Previous', true, false);
    }
    pages.forEach(function (_p, i) {
      makePaginationItem(i + 1, false, false);
    });
    if (currentPage !== pages.length) {
      makePaginationItem('Next', false, true);
    }
  }

  filteredItems.forEach(function (item, key) {
    if (pageItems.includes(key.toString())) {
      item.style.display = '';
    } else {
      item.style.display = 'none';
    }
  });

  document.querySelectorAll('.author-pagination a').forEach(function (a) {
    a.addEventListener('click', handlePaginate);
  });

  replaceUnderscore('.author-list__name');
  replaceUnderscore('.author-list__photo', true);
}

function isVisible(el) {
  return el.style.display !== 'none';
}

function replaceUnderscore(selector, isEntryImage) {
  if (!isEntryImage) {
    document.querySelectorAll(selector).forEach(function (entry) {
      const nameLink = entry.matches('a') ? entry : entry.querySelector('a');
      const target = nameLink || entry;
      target.textContent = cleanAuthorName(target.textContent);
    });
  } else {
    document.querySelectorAll(selector).forEach(function (entry) {
      const imgTag = entry.getElementsByTagName('img')[0];
      if (!imgTag) return;
      imgTag.alt = cleanAuthorName(imgTag.alt);
      const parts = imgTag.alt.split(' ');
      const firstName = parts[0];
      const lastName  = parts.slice(1).join(' ');
      if (lastName) {
        imgTag.alt = firstName + ' ' + lastName;
        imgTag.dataset.lastName = lastName;
      }
    });
  }
}

function cleanAuthorName(name) {
  return (name || '')
    .replace(/_/g, ' ')
    .replace(/\s*\|\s*Authors?\s*$/i, '')
    .trim();
}

function chunk(array, size) {
  size = Math.max(size || 1, 0);
  const length = array == null ? 0 : array.length;
  if (!length || size < 1) return [];
  const result = new Array(Math.ceil(length / size));
  let index = 0;
  let resIndex = 0;
  while (index < length) {
    result[resIndex++] = array.slice(index, (index += size));
  }
  return result;
}

function sortAuthors() {
  function sortByFirstName(a, b) {
    const nameA = (a.dataset.firstName || '').toLowerCase();
    const nameB = (b.dataset.firstName || '').toLowerCase();
    return nameA.localeCompare(nameB);
  }

  const list = Array.from(document.querySelectorAll('.author-list__col'));
  const sorted = list.sort(sortByFirstName);
  sorted.forEach(function (el) {
    el.parentNode.appendChild(el);
  });
}

function sortAuthorsByStartLetter(startLetter) {
  const authors = document.querySelectorAll('.author-list__col');
  authors.forEach(function (author) {
    const firstName = author.dataset.firstName || '';
    const firstLetter = firstName.charAt(0).toLowerCase();

    if (firstLetter !== startLetter.toLowerCase()) {
      author.style.display = 'none';
    } else {
      author.style.display = '';
    }
  });
}
